/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable no-restricted-imports */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router";
import { Link } from "react-router-dom";
import queryString from "query-string";
import _ from "lodash";

import { InputText } from "primereact/inputtext";
import filterIcon from "../../../assets/img/Filter-2.png";
import sortIcon from "../../../assets/img/Filter.png";

import PopupFilter from "./PopupFilter";
import PopupSort from "./PopupSort";
import AdminPaginate from "../../../components/paging/pagination";
import TextBody from "../../../components/datatableBody/TextBody";
import DateBody from "../../../components/datatableBody/DateBody";
import NumberBody from "../../../components/datatableBody/NumberBody";
import StatusBadgeBody from "../../../components/datatableBody/StatusBadgeBody";

import { getProjectClientAction } from "../../../../redux/action/orderAction";

import DataEmpty from "../../../components/emptyState/dataEmpty";
import TableLoader from "../../../components/loading/tableLoader";
import ResponsiveTable from "../../../components/table/ResponsiveTable";
import ResponsiveColumn from "../../../components/table/ResponsiveColumn";

const MyReleaseModule = () => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const parsed = queryString.parse(location.search);

  const [showPopup, setShowPopup] = useState(false);
  const [showSorting, setShowSorting] = useState(false);
  const {
    dataGetProjectClient,
    loadingGetProjectClient,
    totalPage,
  } = useSelector((state) => state.order);

  const statusBodyTemplate = (item) => {
    return (
      <StatusBadgeBody
        status={item.status}
        userType="client"
        link={`/client/order-detail/confirm/${item?._id}`}
      />
    );
  };

  const titleBodyTemplate = (item) => {
    return (
      <TextBody
        text={item.title}
        link={`/client/order-detail/confirm/${item?._id}`}
      />
    );
  };
  const categoryBodyTemplate = (item) => {
    let categoryName;
    if (item?.type === "pr") {
      categoryName = "Press Release";
    } else if (item?.type === "distribution_media") {
      categoryName = "Media Distribusi";
    } else {
      categoryName = "Artikel";
    }
    return (
      <TextBody
        text={categoryName}
        link={`/client/order-detail/confirm/${item?._id}`}
      />
    );
  };
  const typeBodyTemplate = (item) => {
    return (
      <StatusBadgeBody
        status={item.category}
        userType="client"
        link={`/client/order-detail/confirm/${item?._id}`}
      />
    );
  };
  const dateBodyTemplate = (item) => {
    return item?.deadlineDate !== null ? (
      <DateBody
        date={item?.deadlineDate}
        link={`/client/order-detail/confirm/${item?._id}`}
      />
    ) : (
      <TextBody
        text="Belum tersedia"
        link={`/client/order-detail/confirm/${item?._id}`}
      />
    );
  };
  const winnerBodyTemplate = (item) => {
    return (
      <NumberBody
        number={item?.winnerQuota}
        link={`/client/order-detail/confirm/${item?._id}`}
      />
    );
  };
  const priceBodyTemplate = (item) => {
    return (
      <Link
        to={`/client/order-detail/confirm/${item?._id}`}
        className="btn-download"
      >
        Lihat Project
      </Link>
    );
  };

  const searchingHandler = useRef(
    _.debounce((search) => {
      const params = {
        q: search,
        category: parsed?.category || "",
        type: parsed?.type || "",
        orderField: parsed?.order || "",
        orderDir: parsed?.order === "createdAt" ? "desc" : "asc",
        page: 1,
        perpage: 10,
      };

      history.push(
        `/client/my-order/confirm?search=${search}&type=${parsed?.type ||
          ""}&category=${parsed?.category || ""}&order=${parsed?.order ||
          ""}&page=1`
      );
      dispatch(getProjectClientAction(params));
    }, 1000)
  ).current;

  const handleFilter = (e) => {
    e.preventDefault();
    setShowPopup(!showPopup);
    setShowSorting(false);
  };

  const handleSorting = (e) => {
    e.preventDefault();
    setShowPopup(false);
    setShowSorting(!showSorting);
  };

  const paginationHandler = (page) => {
    const params = {
      q: parsed?.search || "",
      category: parsed?.category || "",
      type: parsed?.type || "",
      orderField: parsed?.order || "",
      orderDir: parsed?.order === "title" ? "asc" : "desc",
      page: page + 1,
      perpage: 10,
    };
    dispatch(getProjectClientAction(params));

    history.push(
      `/client/my-order/confirm?search=${parsed?.search ||
        ""}&type=${parsed?.type || ""}&category=${parsed.category ||
        ""}&order=${parsed?.order || ""}&page=${page + 1}`
    );
  };

  return (
    <div className="myrelease-module">
      <div className="d-flex p-justify-between">
        <div className="title">Daftar Project</div>
        <div className="service-card-footer title">
          <button
            className="p-button p-button-primary"
            onClick={() => history.push(`/client/order`)}
            >
            Create Project
          </button>
        </div>
      </div>

      <div className="search-myrelease">
        <div className="d-flex">
          <InputText
            placeholder="Cari"
            onChange={(e) => searchingHandler(e.target.value)}
          />
          <button onClick={handleFilter}>
            <img src={filterIcon} alt="filter" />
          </button>
          <button onClick={handleSorting}>
            <img src={sortIcon} alt="sort" />
          </button>
        </div>
        <p>
          Cari berdasarkan<span> Judul Project</span>
        </p>
      </div>
      <div className="table-list release">
        {loadingGetProjectClient ? (
          <TableLoader />
        ) : (
          <>
            {dataGetProjectClient?.length < 1 ||
            dataGetProjectClient === null ? (
              <DataEmpty />
            ) : (
              <ResponsiveTable
                value={dataGetProjectClient}
                mobileTitle="Judul Project"
              >
                <ResponsiveColumn
                  header="Judul Project"
                  body={titleBodyTemplate}
                ></ResponsiveColumn>
                <ResponsiveColumn
                  header="Deadline"
                  body={dateBodyTemplate}
                ></ResponsiveColumn>
                <ResponsiveColumn
                  header="Penulis"
                  body={winnerBodyTemplate}
                ></ResponsiveColumn>
                <ResponsiveColumn
                  header="Jenis Project"
                  body={typeBodyTemplate}
                ></ResponsiveColumn>
                <ResponsiveColumn
                  header="Kategori"
                  body={categoryBodyTemplate}
                ></ResponsiveColumn>
                <ResponsiveColumn
                  header="Status"
                  body={statusBodyTemplate}
                ></ResponsiveColumn>
                <ResponsiveColumn body={priceBodyTemplate}></ResponsiveColumn>
              </ResponsiveTable>
            )}
          </>
        )}{" "}
      </div>
      <PopupFilter
        show={showPopup}
        parsed={parsed}
        closePopup={() => setShowPopup(false)}
      />
      <PopupSort
        show={showSorting}
        parsed={parsed}
        closePopup={() => setShowSorting(false)}
      />
      {totalPage > 1 && (
        <AdminPaginate
          active={parsed?.page || 1}
          total={totalPage}
          clicked={paginationHandler}
          perpage={10}
        />
      )}
    </div>
  );
};

export default MyReleaseModule;
